/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom';
/* Package JSON Import will be here */

/* Project Import will be here */
import SelectTaskCodeComponent from './selectTaskCode.Component';
import { MessageBox } from '../../sharedComponent/messageBox';
import { Constants } from '../../../config/appConstants';
import { ApiUrls } from '../../../services/api';
import Api from '../../../services/api/serviceCall';

/* Const,Let & Var will be here */

class SelectTaskCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            taskCodeOptions: [],
            searchText: "",

            selectedProjectID: props.selectedProjectID,
            selectedProjectNumber: props.selectedProjectNumber,
            selectedTaskNumber: props.selectedTaskNumber,
            selectedTaskName: props.selectedTaskName,
            taskGrpList: [],
            activeTaskGroupIds: [],
            activeIndexForTaskGroup: [],
            assignedProjectNumberList: [],
            availableTaskList: []
        };
    };

    componentDidMount() {
        this.getProjectList();
        this.getTaskGroup();
    }
    getTaskGroup() {
        let { taskGrpList, activeTaskGroupIds, activeIndexForTaskGroup } = this.state;
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_TSK_GRP_M}?deviceId=${this.props.device.deviceId}`;
        Api.Get(url, this).then((responseData) => {
            try {
                if (responseData.success) {
                    if (responseData.data && responseData.data.length > 0) {
                        activeTaskGroupIds = responseData.data.map(a => parseInt(a.taskCodeID));
                        responseData.data.map(data => {
                            data.id = parseInt(data.taskCodeID);
                        });
                        taskGrpList = responseData.data.reduce((prev, curr) => {
                            if (curr.groupID) {
                                var previousData = prev.find(a => a.groupID == curr.groupID);
                                if (prev && previousData) {
                                    previousData.groupData = [...previousData.groupData || [], curr];
                                }
                                else {
                                    prev.push({
                                        groupID: curr.groupID,
                                        groupName: curr.groupName,
                                        groupData: [curr],
                                    });
                                }
                                return prev;
                            }
                            else {
                                prev = [];
                                return prev;
                            }
                        }, []);

                        taskGrpList.sort((a, b) =>(a.groupName > b.groupName) ? 1 : -1);

                        taskGrpList.map(selectedTask => {
                            selectedTask.groupData.sort((a, b) => (a.taskNumber > b.taskNumber) ? 1 : -1)});
                            
                        activeIndexForTaskGroup = taskGrpList.map(a => a.groupID);
                        this.setState({ taskGrpList, activeTaskGroupIds, activeIndexForTaskGroup }, () => { this.getTaskCodes(); });
                    } else {
                        this.getTaskCodes();
                    }
                }
                else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            }
            catch (err) {
                MessageBox(err.message, Constants.ERROR);
            }
        });
    }

    getTaskCodes() {
        let { selectedProjectID, selectedProjectNumber, taskCodeOptions, availableTaskList } = this.state;
        let requestData = (this.state.searchText) ? {
            SearchText: [
                { fieldName: "projectTaskName", value: this.state.searchText }
            ]
        } : {};

        if (selectedProjectID > 0) {
            let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_AAPTKBDID_M}?projectId=${selectedProjectID}&projectNumber=${selectedProjectNumber}`;
            Api.Post(url, requestData, this).then((responseData) => {
                try {
                    if (responseData.success && responseData.data) {
                        taskCodeOptions = responseData.data;
                        if(!this.state.searchText){
                            availableTaskList = responseData.data;
                        }
                        this.setState({ taskCodeOptions, availableTaskList });
                    }
                    else {
                        MessageBox(responseData.message, Constants.ERROR);
                    }
                }
                catch (err) {
                    MessageBox(err.message, Constants.ERROR);
                }
            });
        }
    }

    onSearchTaskCodes(event) {
        this.setState({ searchText: event.target.value }, () => {
            this.getTaskCodes();
        });
    }

    onSelectTaskCodeOption(value) { 
        let { availableTaskList } = this.state;    
        let findTaskCode = availableTaskList.find(a => a.taskName === value.taskName && a.taskNumber === value.taskNumber);
        if(findTaskCode){
            this.props.onHandleTaskCodeSelection(findTaskCode.id, findTaskCode.taskName, findTaskCode.taskNumber);
        }
    }

    onClickBackButton() {
        this.props.onHandleBackButton();      
    }

    handleClickForTaskGrp = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndexForTaskGroup } = this.state
        let findIndexOfTaskGroupId = activeIndexForTaskGroup.findIndex(taskGroupId => taskGroupId === index);
        if(findIndexOfTaskGroupId >= 0){
            activeIndexForTaskGroup.splice(findIndexOfTaskGroupId, 1);
        }else{
            activeIndexForTaskGroup.push(index)
        }
        this.setState({ activeIndexForTaskGroup })
    }

    getProjectList() {
        let { assignedProjectNumberList } = this.state;
        let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_AAPBDID_M}?deviceId=${this.props.device.deviceId}`;
        Api.Post(url, {}, this, false).then((responseData) => {
            try {
                if (responseData.success && responseData.data) {

                    responseData.data.map((prj) => {
                        assignedProjectNumberList.push(prj.projectNumber)
                    });

                    this.setState({ assignedProjectNumberList });
                }
                else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            }
            catch (err) {
                MessageBox(err.message, Constants.ERROR);
            }
        });

    }

    render() {
        const { taskCodeOptions, searchText, selectedTaskNumber, selectedTaskName, taskGrpList, activeIndexForTaskGroup, assignedProjectNumberList,
            selectedProjectNumber, availableTaskList } = this.state;
        return (
            <Fragment>
                <SelectTaskCodeComponent
                    {...{
                        selectTaskCode: {
                            taskCodeOptions,
                            searchText,                           
                            selectedTaskNumber,
                            selectedTaskName,
                            taskGrpList,
                            activeIndexForTaskGroup,
                            assignedProjectNumberList,
                            selectedProjectNumber,
                            availableTaskList
                        }
                    }}
                    onSearchTaskCodes={this.onSearchTaskCodes.bind(this)}
                    onSelectTaskCodeOption={this.onSelectTaskCodeOption.bind(this)}
                    onClickBackButton={this.onClickBackButton.bind(this)}
                    handleClickForTaskGrp={this.handleClickForTaskGrp.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device
    };
}

export default withRouter(connect(mapStateToProps)(SelectTaskCode));

SelectTaskCode.displayName = 'SelectTaskCode';